import { motion, HTMLMotionProps } from "framer-motion";

type DivProps = React.HTMLAttributes<HTMLDivElement>;
type MotionDivProps = HTMLMotionProps<"div">;

export const Wrapper = ({ className = "", ...rest }: DivProps) => (
  <div className={`flex ${className}`} {...rest} />
);

export const PageContainer = ({ className = "", ...rest }: MotionDivProps) => (
  <motion.div
    className={`flex flex-col flex-grow bg-[#f8f8fb] ${className}`}
    {...rest}
  />
);
